var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { UserRole } from "@/share/InternalUserStat";
import { UserStatus } from "@@/Group";
import { observable, action, makeObservable } from "mobx";
import { NewUserPinState } from "../UIComponents/NewUserPinDialog";
import { UserRolePickerState } from "../UIComponents/RolePicker";
// import { User } from "../../model/User";
// import { AEvent } from "../../events/AppEvent";
// import { UStore } from "../UsersStore";
// import { ExternalContact } from "../../model/ExternalContact";
// import { UserRolePickerState } from "../../components/RolePicker";
// import { ChangeRole, UserRole } from "../../communication/comm";
export var AdminContactPanels;
(function (AdminContactPanels) {
    AdminContactPanels[AdminContactPanels["InternalContact"] = 0] = "InternalContact";
    AdminContactPanels[AdminContactPanels["LetrwingContact"] = 1] = "LetrwingContact";
})(AdminContactPanels || (AdminContactPanels = {}));
export class EditUserViewStore {
    constructor() {
        this.open = false;
        this.name = "";
        this.role = UserRole.User;
        this.updating = false;
        this.active = false;
        this.edituserid = "";
        this.error = "";
        makeObservable(this);
        APPEvent.addSubscriberForAdminCancelInviteRes((res) => {
            var _a;
            (_a = this.oncancelinvitecb) === null || _a === void 0 ? void 0 : _a.call(this, res);
        });
        APPEvent.addSubscriberForAdminUpdateUserDetailRes((res) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (res.success) {
                (_a = this.activeuser) === null || _a === void 0 ? void 0 : _a.setRole(this.role);
                if (((_b = this.activeuser) === null || _b === void 0 ? void 0 : _b.status) == UserStatus.Active || ((_c = this.activeuser) === null || _c === void 0 ? void 0 : _c.status) == UserStatus.Disable) {
                    (_d = this.activeuser) === null || _d === void 0 ? void 0 : _d.setStatus(this.active ? UserStatus.Active : UserStatus.Disable);
                }
                (_e = this.activeuser) === null || _e === void 0 ? void 0 : _e.setName(this.name);
            }
            else {
                if (((_f = this.activeuser) === null || _f === void 0 ? void 0 : _f.status) == UserStatus.Disable && this.active) {
                    this.setError("Sorry, failed to update user detail.Might be your user quota is running low");
                }
                else {
                    this.setError("Sorry, failed to update user detail. Please contact support if issue persist");
                }
            }
            this.setUpdating(false);
            this.setShow(false);
            (_g = this.oncancelinvitecb) === null || _g === void 0 ? void 0 : _g.call(this, res.success);
        });
    }
    setError(error) {
        this.error = error;
    }
    setActive(ac) {
        this.active = ac;
    }
    setUserRole(role) {
        this.role = role;
    }
    setName(name) {
        this.name = name;
    }
    setUpdating(up) {
        this.updating = up;
    }
    setShow(show) {
        this.open = show;
        if (!show) {
            this.setUpdating(false);
            this.setError("");
        }
    }
    async cancelInvite(userid) {
        const req = {
            userid: userid
        };
        Apphandler.sendMessage('admincancelinvite', req);
    }
    async update() {
        let userid = "";
        if (this.edituserid) {
            userid = this.edituserid;
        }
        else if (this.activeuser) {
            userid = this.activeuser.id;
        }
        if (!userid) {
            return undefined;
        }
        this.setUpdating(true);
        const req = {
            name: this.name,
            newrole: this.role,
            disableuser: this.active,
            userid: userid
        };
        Apphandler.sendMessage('adminupdateuserdetail', req);
        // if (await UStore.updateUserDetail(this.name, this.role, this.active, this.activeuser.id)) {
        //     this.activeuser?.setRole(this.role);
        //     if (this.activeuser?.status == UserStatus.Active || this.activeuser?.status == UserStatus.Disable) {
        //         this.activeuser?.setStatus(this.active ? UserStatus.Active: UserStatus.Disable);
        //     }
        //     this.activeuser?.setName(this.name);
        // }else {
        //     if (this.activeuser?.status == UserStatus.Disable &&  this.active) {
        //         this.setError("Sorry, failed to update user detail.Might be your user quota is running low");
        //     }else {
        //         this.setError("Sorry, failed to update user detail. Please contact support if issue persist");
        //     }
        // }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], EditUserViewStore.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], EditUserViewStore.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], EditUserViewStore.prototype, "role", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], EditUserViewStore.prototype, "updating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], EditUserViewStore.prototype, "active", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], EditUserViewStore.prototype, "error", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditUserViewStore.prototype, "setError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], EditUserViewStore.prototype, "setActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditUserViewStore.prototype, "setUserRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditUserViewStore.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], EditUserViewStore.prototype, "setUpdating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], EditUserViewStore.prototype, "setShow", null);
export class UserView {
    constructor() {
        this.id = "";
        this.name = "";
        this.lastloggedintime = 0;
        this.roleid = UserRole.User;
        this.status = UserStatus.Active;
        this.selected = false;
        this.orgcontactvisible = false;
        this.error = "";
        this.orgname = "";
        this.email = "";
        makeObservable(this);
    }
    toggleSelection() {
        this.selected = !this.selected;
    }
    setRole(roleid) {
        this.roleid = roleid;
    }
    setStatus(status) {
        this.status = status;
    }
    setOrgContactVisibile(vis) {
        this.orgcontactvisible = vis;
    }
    setName(name) {
        this.name = name;
    }
    setEmail(email) {
        this.email = email;
    }
    setOrgName(name) {
        this.orgname = name;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], UserView.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UserView.prototype, "roleid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserView.prototype, "status", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserView.prototype, "selected", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserView.prototype, "orgcontactvisible", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserView.prototype, "error", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserView.prototype, "orgname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserView.prototype, "email", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserView.prototype, "toggleSelection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserView.prototype, "setRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserView.prototype, "setStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserView.prototype, "setOrgContactVisibile", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserView.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserView.prototype, "setEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserView.prototype, "setOrgName", null);
export class UsersViewStore {
    constructor() {
        this.loadStatus = 0;
        this.userMap = new Map();
        this.loadingUsers = false;
        this.externalContacts = [];
        this.externalloadstatus = 0;
        this.addNewUser = false;
        this.selectedExternalContacts = new Set();
        this.addingNewuser = false;
        this.rolepickerstate = new UserRolePickerState();
        this.selectedContactPanel = AdminContactPanels.InternalContact;
        makeObservable(this);
        // AEvent.addSubscriberForUsers((users: User[]) => {
        //     this.setUsers(users);
        // });
        this.resetpinstate = new NewUserPinState();
        this.resetpinstate.okcb = (pin) => {
            const req = {
                userid: this.resetpinstate.userid,
                password: pin
            };
            Apphandler.sendMessage("adminresetpassword", req);
        };
        APPEvent.addSubcriberForAdminUsersRes((users) => {
            this.setLoadStatus(2);
            this.setUsers(users);
        });
        APPEvent.addSubscriberForAddInternalUserRes((res) => {
            if (res) {
                this.setUsers([res]);
                this.setAddnewuser(false);
            }
            this.setAddingNewUser(false);
        });
        APPEvent.addSubscriberForAdminEditUserRequestRes((res) => {
            var _a;
            let ret = true;
            for (const editres of res) {
                if (!editres.success) {
                    ret = false;
                    break;
                }
            }
            (_a = this.oneditusercb) === null || _a === void 0 ? void 0 : _a.call(this, ret);
        });
        APPEvent.addSubscriberForAdminLetrwingContactsRes((res) => {
            this.setExternalContacts(res);
            this.setExternalLoadStatus(2);
        });
        APPEvent.addSubscriberForAdminDeleteLetrwingContactRes((res) => {
            var _a;
            let ret = true;
            for (const editres of res) {
                if (editres.success) {
                    this.removeExternalContactFromList(editres.connectid);
                }
                if (ret && !editres.success) {
                    ret = false;
                }
            }
            (_a = this.ondeletelwcontactcb) === null || _a === void 0 ? void 0 : _a.call(this, ret);
        });
        APPEvent.addSubscriberForAdminPassword((pas) => {
            if (pas.userid !== this.resetpinstate.userid || !this.resetpinstate.resetting) {
                return;
            }
            if (pas.ok) {
                // lets just tell user about it!
                this.resetpinstate.setResetting(false);
                this.resetpinstate.setOpen(false);
            }
            else {
                APPEvent.publishApperror("Sorry, failed to reset the password");
                this.resetpinstate.setResetting(false);
            }
        });
    }
    setSelectedContactPanel(cont) {
        this.selectedContactPanel = cont;
    }
    async applyRole(role) {
        // const srole: ChangeRole[] = [];
        // for(const id of this.getSelected()) {
        //     srole.push({userid: id.id, roleid: role});
        // }
        const req = [];
        for (let user of this.getSelected()) {
            req.push({
                name: user.name,
                newrole: role,
                disableuser: true,
                userid: user.id
            });
        }
        Apphandler.sendMessage('adminedituser', req);
        // await UStore.changeRoles(srole);
        for (const id of this.getSelected()) {
            id.setRole(role);
        }
    }
    removeInternalUser(u) {
        this.userMap.delete(u.id);
    }
    externalContactSelected(id) {
        return this.selectedExternalContacts.has(id);
    }
    async deleteSelectedConnection() {
        const conn = this.externalContacts.filter((es) => this.selectedExternalContacts.has(es.connectionid));
        if (conn.length > 0) {
            const req = [];
            for (let c of conn) {
                req.push({
                    connectid: c.connectionid,
                    userid: c.internaluserid
                });
            }
            Apphandler.sendMessage('admindeleteletrwingcontact', req);
            // for(const c of conn) {
            //     // const res = await UStore.deleteConnection(c.connectionid, c.internaluserid);
            //     // if(res) {
            //     //     this.removeExternalContactFromList(c);
            //     // }
            // }
        }
    }
    async addNewInternalUser(email, name) {
        this.setAddingNewUser(true);
        const req = {
            name: name,
            email: email,
            role: UserRole.User
        };
        Apphandler.sendMessage('addinternaluser', req);
        // const res = await UStore.addNewInetrnaluser(email, name);
        // if(res) {
        //     this.setUsers([res]);
        // }
        // this.setAddingNewUser(false);
        // return res;
    }
    setAddingNewUser(add) {
        this.addingNewuser = add;
    }
    setAddnewuser(open) {
        this.addNewUser = open;
    }
    removeExternalContactFromList(connectid) {
        var index = this.externalContacts.map(item => item.connectionid).indexOf(connectid);
        if (index > -1) {
            this.externalContacts.splice(index, 1);
        }
        this.selectedExternalContacts.delete(connectid);
    }
    toggleExternalContactSel(id) {
        if (this.selectedExternalContacts.has(id)) {
            this.selectedExternalContacts.delete(id);
        }
        else {
            this.selectedExternalContacts.add(id);
        }
    }
    async checkAndLoadExternalUser() {
        if (this.externalloadstatus < 1) {
            this.setExternalLoadStatus(1);
            Apphandler.sendMessage("admingetletrwingcontacts", "");
            // const con = await this.loadExternalContacts();
            // if(con !== undefined) { 
            //     this.setExternalContacts(con);
            // }
        }
    }
    setExternalContacts(conts) {
        this.externalContacts = conts;
    }
    setExternalLoadStatus(st) {
        this.externalloadstatus = st;
    }
    async checkAndLoadusers() {
        if (this.loadStatus < 1) {
            this.setLoadStatus(1);
            this.loadUsers();
            // this.setLoadStatus(2);
        }
    }
    async loadUsers() {
        // await UStore.getUsers();
        Apphandler.sendMessage("adminusers", "");
    }
    setLoadStatus(st) {
        this.loadStatus = st;
    }
    setUsers(users) {
        users.forEach((u) => {
            this.userMap.set(u.id, this.convertUserToUserView(u));
        });
    }
    async loadExternalContacts() {
        // return await UStore.getExternalContacts();
    }
    get users() {
        return Array.from(this.userMap.values());
    }
    getMiniContactInfo() {
        const contacts = Array.from(this.userMap.values());
        const ret = [];
        contacts.forEach((u) => {
            ret.push(this.convertUserViewToMiniContactInfo(u));
        });
        console.log(ret);
        return ret;
    }
    getSelected() {
        return this.users.filter((u) => u.selected);
    }
    totalSelected() {
        return this.users.reduce((pv, cv) => cv.selected ? ++pv : pv, 0);
    }
    getUser(id) {
        return this.userMap.get(id);
    }
    convertUserViewToMiniContactInfo(user) {
        const ret = {
            id: user.id,
            name: user.name,
            orgname: user.orgname,
            imageprofileurl: '',
            email: user.email,
            phonenumber: '',
            userstatus: user.status,
            role: user.roleid
        };
        return ret;
    }
    async diableSelected() {
        const users = this.getSelected();
        const req = [];
        for (let user of users) {
            req.push({
                name: user.name,
                newrole: user.roleid,
                disableuser: false,
                userid: user.id
            });
        }
        Apphandler.sendMessage('adminedituser', req);
        // const res = await UStore.disableUsers(users.map(u => u.id));
        // if(res) {
        //     users.forEach((u) => u.setStatus(UserStatus.Disable));
        // }
        // return res;
    }
    async enableSelected() {
        const users = this.getSelected();
        let uids = [];
        for (let user of users) {
            uids.push(user.id);
        }
        const req = {
            userid: uids
        };
        Apphandler.sendMessage('adminenableusers', req);
        // const res = await UStore.disableUsers(users.map(u => u.id));
        // if(res) {
        //     users.forEach((u) => u.setStatus(UserStatus.Disable));
        // }
        // return res;
    }
    convertUserToUserView(user) {
        var _a;
        const ret = new UserView();
        ret.id = user.id;
        ret.setName(user.name);
        ret.lastloggedintime = user.lastloggedintime;
        ret.setRole((_a = user.roleid) !== null && _a !== void 0 ? _a : UserRole.User);
        ret.setStatus(user.status);
        ret.setOrgContactVisibile(user.orgcontactvisible);
        ret.setEmail(user.email);
        return ret;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], UsersViewStore.prototype, "loadStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], UsersViewStore.prototype, "userMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UsersViewStore.prototype, "loadingUsers", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], UsersViewStore.prototype, "externalContacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UsersViewStore.prototype, "externalloadstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UsersViewStore.prototype, "addNewUser", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], UsersViewStore.prototype, "selectedExternalContacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UsersViewStore.prototype, "addingNewuser", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], UsersViewStore.prototype, "selectedContactPanel", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "setSelectedContactPanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UserView]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "removeInternalUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "setAddingNewUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "setAddnewuser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "removeExternalContactFromList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "toggleExternalContactSel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "setExternalContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "setExternalLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "setLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], UsersViewStore.prototype, "setUsers", null);
